// import { storeGetters } from "../../getters.constants";

const commonGetters = {};
export default { ...commonGetters };
